import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, Redirect } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';

import { I18nProvider, LOCALES } from './i18n';
import { FormattedMessage } from 'react-intl';
import { api_url } from './Constants';
//import translate from './i18n/translate';
import LanguageBtn from './LanguageBtn';



const SettingComponent = (props) => {
    let { id } = useParams();

    const [details, setDetails] = useState([]);
    const [lists, setList] = useState([]);
    const [doc_url, setDoc_url] = useState();
    const [locale, setLocale] = useState();
    const [showTitle, setShowTitle] = useState('');

    const [lblDocumentDetails, setDocumentDetails] = useState('');
    const [lblDocument, setDocument] = useState('');
    const [lblLibraryItemID, setLibraryItemID] = useState('');
    const [btnView, setView] = useState('');
    const [btnDownload, setDownload] = useState('');
    const [lblAuthor, setAuthor] = useState('');
    const [separator, setSeparator] = useState(true);
    const [languageData, setLanguageData] = useState([]);

    const [lblTopic, setLblTopic] = useState('');
    const [lblCategory, setLblCategory] = useState('');
    const [lblType, setLblType] = useState('');


    let docData = props.location.mydata;

    useEffect(() => {
        loadDocumentsDetails();
        localSelect();
        selectedLanguageData();
    }, []);


    const localSelect = () => {
        let getLangs = localStorage.getItem('language');
        // if (getLangs === "French") {
        //     setLocale(LOCALES.FRENCH);
        //     setShowTitle("French");
        // }
        // else if (getLangs === "Arabic") {
        //     setLocale(LOCALES.ARABIC);
        //     setShowTitle("Arabic");
        // }
        // else {
        //     setLocale(LOCALES.ENGLISH);
        //     setShowTitle("English");
        // }
    }

    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    }
    // docData.docId
    let getformData = new FormData();
    let document = props.location.mydata;
    getformData.set('documentID', id);
    getformData.set('language_id', localStorage.getItem('languageId'));


    let getLanFormData = new FormData();
    getLanFormData.set('language_id', localStorage.getItem('languageId'));

    const loadDocumentsDetails = async () => {
        const result = await axios.post('api/getdocumentdetail', getformData, config)
        console.log(result.data);
        setDetails(result.data);
    }


    const handleClick = event => {
        setDoc_url(api_url+'assets' + event.target.dataset.url);
        localStorage.setItem('docurl', api_url+'assets' + event.target.dataset.url);
        let path = `/story`;
        // history.push(path);
    }


    const selectedLanguageData = async () => {

        let getLang = localStorage.getItem('language');
        const result = await axios.post('api/get_translated_captions', getLanFormData, config);
        console.log('********=>', result.data.length);
        setLanguageData(result.data);
        if (getLang === 'English') {
            setSeparator(false);
        }
        if (result.data.length < 1) {
            setShowTitle("English");
            setSeparator(false);
        }
        else {
            setShowTitle(getLang);
        }

        {
            result.data.map(lanData => {
                lanData.caption_key === "lblDocumentDetails" &&
                    setDocumentDetails(lblDocumentDetails => [...lblDocumentDetails, lanData.translated_text]);

                lanData.caption_key === "lblDocuments" &&
                    setDocument(lblDocument => [...lblDocument, lanData.translated_text]);

                lanData.caption_key === "lblLibraryItemID" &&
                    setLibraryItemID(lblLibraryItemID => [...lblLibraryItemID, lanData.translated_text]);

                lanData.caption_key === "btnView" &&
                    setView(btnView => [...btnView, lanData.translated_text]);

                lanData.caption_key === "btnDownload" &&
                    setDownload(btnDownload => [...btnDownload, lanData.translated_text]);

                lanData.caption_key === "lblAuthor" &&
                    setAuthor(lblAuthor => [...lblAuthor, lanData.translated_text]);

                lanData.caption_key === "lblTopic" &&
                    setLblTopic(lblTopic => [...lblTopic, lanData.translated_text]);

                lanData.caption_key === "lblType" &&
                    setLblType(lblType => [...lblType, lanData.translated_text]);

                lanData.caption_key === "lblCategory" &&
                    setLblCategory(lblCategory => [...lblCategory, lanData.translated_text]);

            }

            )
        }
    }


    return (
        <div>

            <div className="container top-header text-center">
                <h4>
                    <Link to="/list">
                        <i className="fa fa-arrow-left fa-1x pt-2 pull-left" aria-hidden="true"></i>
                    </Link>

                    Document Details {separator === true ? '/ ' : ''}{showTitle !== 'English' ? lblDocumentDetails : ''}
                </h4>
            </div>

            {/* {details.map(detail => */}
            <div className="container pl-3 py-3 file-title">
                {details.title_translated}
                <hr style={{ borderTop: '0.5px solid #fff' }} />
                {details.title}
            </div>
            {/* )} */}


            <div className="container file-details mt-2">
                <div className="py-1">
                    {details.topic_translated != '' &&
                        <div className="row no-gutters">
                            <div className="col-3">
                                <h6>{lblTopic}</h6>
                            </div>
                            <div className="col-9   ">
                                {details.topic_translated}
                            </div>
                        </div>
                    }
                    <div className="row no-gutters">

                        <div className="col-3">
                            <h6>Topic</h6>
                        </div>
                        <div className="col-9">
                            <p>{details.topic_name}</p>
                        </div>
                    </div>

                    <div className="row no-gutters">
                        <div className="col-3">
                            <h6>{showTitle !== 'English' ? lblAuthor : ''}{separator === true ? '/ ' : ''}Author</h6>
                        </div>
                        <div className="col-9">
                            <p>{details.author}</p>
                        </div>
                    </div>

                    {details.type_translated != '' &&
                        <div className="row no-gutters">
                            <div className="col-3">
                                <h6>{lblType}</h6>
                            </div>
                            <div className="col-9">
                                {details.type_translated}
                            </div>
                        </div>
                    }

                    <div className="row no-gutters">
                        <div className="col-3">
                            <h6>Type</h6>
                        </div>
                        <div className="col-9">
                            <p>{details.type_name}</p>
                        </div>
                    </div>

                    {details.author_contact != '' && details.author_contact != null &&
                        <div className="row no-gutters">
                          <div className="col-3">
                            <h6>Author Contact</h6>
                          </div>
                          <div className="col-9">
                            <p><a onClick={()=>{window.open(details.author_contact,'_blank')}} style={{cursor: "pointer"}}><u>Author Contact</u></a></p>
                          </div>
                        </div>
                    }

                    {details.countryName != '' && details.countryName != null &&
                        <div className="row no-gutters">
                          <div className="col-3">
                            <h6>Country</h6>
                          </div>
                          <div className="col-9">
                            <p>{details.countryName}</p>
                          </div>
                        </div>
                      }

                      {details.provinceName != '' && details.provinceName != null &&
                        <div className="row no-gutters">
                          <div className="col-3">
                            <h6>Province</h6>
                          </div>
                          <div className="col-9">
                            <p>{details.provinceName}</p>
                          </div>
                        </div>
                      }

                    {details.publication_date != '' && details.publication_date != null &&
                        <div className="row no-gutters">
                          <div className="col-3">
                            <h6>Publication Date</h6>
                          </div>
                          <div className="col-9">
                            <p>{details.publication_date}</p>
                          </div>
                        </div>
                      }

                      {details.sponsered_by != '' && details.sponsered_by != null &&
                        <div className="row no-gutters">
                          <div className="col-3">
                            <h6>Sponsored/Endorsed By</h6>
                          </div>
                          <div className="col-9">
                            <p>{details.sponsered_by}</p>
                          </div>
                        </div>
                      }

                      {details.item_note_en != '' && details.item_note_en != null &&
                        <div className="row no-gutters">
                          <div className="col-3">
                            <h6>Item Note - EN</h6>
                          </div>
                          <div className="col-9">
                            <p>{details.item_note_en}</p>
                          </div>
                        </div>
                      }

                      {details.item_note_fr != '' && details.item_note_fr != null &&
                        <div className="row no-gutters">
                          <div className="col-3">
                            <h6>Item Note - FR</h6>
                          </div>
                          <div className="col-9">
                            <p>{details.item_note_fr}</p>
                          </div>
                        </div>
                      }
                </div>
            </div>



            <div className="container file-details mt-2">
                <h5 className="pt-2">{showTitle !== 'English' ? lblDocument : ''}{separator === true ? '/ ' : ''} Documents</h5>
                <hr />


                <div className="">
                    {showTitle !== 'English' ? lblLibraryItemID : ''}{separator === true ? '/ ' : ''} Library Item ID: {details.documentItemID}
                    <h5>{details.title}</h5>


                    <div className="text-right mt-1">
                        {details.master_docUrl !== '' && details.master_item_id!=null && 
                            <a onClick={() => { window.open(api_url+'document/view/'+details.master_item_id+'2','_blank')}} type="text" className="btn btn-outline-danger" data-url={details.docUrl}>
                                <i className="fa fa-eye mr-2" aria-hidden="true"></i>View{separator === true ? '/ ' : ''}{showTitle !== 'English' ? btnView : ''}</a>
                        }

                        {details.master_docUrl !== '' && details.master_item_id!=null &&
                            <a onClick={() => { window.open(api_url+'document/view/'+details.master_item_id+'1','_blank')}} type="text" className="btn btn-danger ml-1" style={{ color: "white" }} download>
                                <i className="fa fa-download mr-2" aria-hidden="true"></i>Download{separator === true ? '/ ' : ''}{showTitle !== 'English' ? btnDownload : ''}</a>
                        }
                    </div>
                </div>
                <hr />
                <div className="">
                    {showTitle !== 'English' ? lblLibraryItemID : ''}{separator === true ? '/ ' : ''} Library Item ID: {details.documentItemID}
                    <h5>{details.title_translated}</h5>
                    <div className="text-right mt-1">
                        {details.translated_docUrl !== '' &&
                            <a type="text" className="btn btn-outline-danger" onClick={() => {window.open(api_url+'document/view/'+details.documentItemID+'2','_blank')}} >
                                <i className="fa fa-eye mr-2" aria-hidden="true"></i>View{separator === true ? '/ ' : ''}{showTitle !== 'English' ? btnView : ''}</a>
                        }
                        {details.translated_docUrl !== '' &&
                            <a onClick={() => { window.open(api_url+'document/view/'+details.documentItemID+'1','_blank')}} type="text" className="btn btn-danger ml-1" style={{ color: "white" }} download>
                                <i className="fa fa-download mr-2" aria-hidden="true"></i>Download{separator === true ? '/ ' : ''}{showTitle !== 'English' ? btnDownload : ''}</a>
                        }


                    </div>

                </div>

            </div>
            <Link to="/rechoose_language">
                <LanguageBtn />
            </Link>
            
        </div>
    );
};

export default SettingComponent;
